import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { Box, Col, Row } from "@intech/web-ui";
import { device } from "../../../device";

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
  align-items: baseline;
  width: 100%;
`;

export const AutoColumn = styled(Col)`
  width: 100%;
  @media ${device.tablet} {
    flex: 1 0 30%;
    max-width: 30%%;
  }
  @media not ${device.tablet} {
    flex: 1 0 100%;
    max-width: 100%%;
  }
`;

export const GrayBox = styled(Box)`
  color: #7c7e80;
`;

export const BoxTitle = styled.div`
  display: flex;
  flex-direction: row;
  padding: 14px 15px 7px;
`;